import React from 'react';
import ReactDOM from 'react-dom';
import './styles/main_styles.css';
import App from './App';

let apiFile = location.protocol + '//shabtzak.com/server/ajax.php';

ReactDOM.render(<App />, document.getElementById('root'));
